import React, { useEffect, useState } from 'react';
import './chat.scss'

import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  ConversationList,
  Conversation,
  ConversationHeader,
  Search,
  Avatar,
  Sidebar
} from "@chatscope/chat-ui-kit-react";

import { Tooltip } from 'antd';
import { Button } from '@life-line-lab/components-react';
import { isNil, omit, sortBy, map, orderBy } from 'lodash';
import moment from 'moment';// todo: move to normalizer
import Icon, {
  WechatOutlined,
  CloseOutlined,
  LeftOutlined
} from '@ant-design/icons';
import classNames from "classnames";
import { BasicModal } from "@life-line-lab/components-react";
import { useTranslation } from 'react-i18next';
import useIsMobile from 'Hooks/is-mobile.hook';


export const ChatComponent: React.FC<any> = ({
  sendStatus, onlineUserlist, onClickUpload,
  isSupplier, onSendMessage,
  navigateToSupplierPage,
  chatBoxStatus,
  defaultMsg,
  conversation,
  setChatWidgetStatus,
  list, onSelUser,
  onProductsUpload,
  onOrdersUpload,
  showConversationContainer,
  setShowConversationContainer,
}) => {

  // const [showChatWidget, setShowChatWidget] = useState(false)
  const [receveSearchTerm, setReceveSearchTerm] = useState('');

  const [customerList, setCustomerList] = useState<any>([])
  const [selCustomer, setSelCustomerConversation] = useState<any>()
  const [input, setInput] = useState<any>({});
  const [isFromSupplier, setIsFromSupplier] = useState<any>(isSupplier ? isSupplier : false)
  const [onlineUsers, setOnlineUsers] = useState<any>([])
  const [isOpen, setIsOpen] = useState<any>(false);
  const [imageUrl, setImageUrl] = useState<any>('')
  const [showPopup, setShowPopup] = useState<any>(false)
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  useEffect(() => {
    setIsFromSupplier(false)
  }, [])


  useEffect(() => {
    //createdAt
    // let cList = sortBy(list ? sortBy(list?.usersList, 'total_unread') : [])
    let cusList = orderBy(list?.usersList, 'unreadCnt', 'desc')
    // console.log(cusList)
    setCustomerList(cusList)
  }, [list])


  useEffect(() => {
    setOnlineUsers(onlineUserlist)
  }, [onlineUserlist])

  useEffect(() => {
    if (customerList.length && isSupplier) {
      setIsFromSupplier(isSupplier)
    }
  }, [isSupplier, customerList])

  useEffect(() => {
    setSelCustomerConversation(conversation)
  }, [conversation])

  useEffect(() => {
    setInput({ ...input, message: defaultMsg });
  }, [defaultMsg])

  const onChange = (event) => {
    setInput({ ...input, message: event });
  }

  const onSend = () => {
    if (sendStatus == 'idle') {
      onSendMessage(input)
      // if (customerList.length) {
      //   map(customerList, (obj, i) => {
      //     if (obj.name == selCustomer.name) {
      //       obj.lastMsg = input.message;
      //       return obj;
      //     }
      //   })
      //   setCustomerList(customerList);
      // }

      setTimeout(() => {
        setInput({ ...input, message: '' });
      }, 100);
    }
  }

  const filterSearch = (event) => {
    let searchVal = event.target.value.toLowerCase();
    setReceveSearchTerm(searchVal);
  }


  const fetchSelUser = (user, index) => {
    setInput({ ...input, selUser: user });
    onSelUser(user)
    map(customerList, (obj, i) => {
      if (i == index) {
        obj.unreadCnt = 0;
        obj.total_unread = 0;
        return obj;
      }
    })
    setCustomerList(customerList);
  }

  const navigateToMerchant = (obj) => {
    setChatWidgetStatus(false);
    //  setCustomerList([])
    setTimeout(() => {
      navigateToSupplierPage(obj.refID)
    }, 2000);
  }


  const handleClose = () => {
    setReceveSearchTerm('');

    setIsFromSupplier(false)

    setChatWidgetStatus(!chatBoxStatus)
    setShowConversationContainer(false);
  }

  const isOnline = (obj) => {
    let status = false;
    map(onlineUsers, (user, i) => {
      if (user.refID == obj.refID) {
        status = true
      }
    })
    return status ? 'available' : 'unavailable';
  }

  const onAttachClick = (event) => {
    onClickUpload()
  }

  const onOpenPopover = () => {
    setShowPopup(true)
  }

  const localFileUpload = () => {
    setShowPopup(false)
    onClickUpload()
    //onFileUpload()
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const viewImage = (url) => {
    setImageUrl(url)
    setIsOpen(true)
  }

  const productsUpload = () => {
    setShowPopup(false)
    onProductsUpload(input.selUser)
    // map(customerList, (obj, i) => {
    //     if (obj.name == selCustomer.name) {
    //         obj.lastMsg = 'Product';
    //         return obj;
    //     }
    // })
    // setCustomerList(customerList);
  }

  const ordersUpload = () => {
    setShowPopup(false)
    onOrdersUpload(input.selUser)
  }


  const isMobileNotInConversation = !showConversationContainer && isMobile;
  const isMobileInConversation = showConversationContainer && isMobile;
  return (

    <div className="chat-component">

      <div className={classNames('chat-floating-button', { 'hide': chatBoxStatus })}>
        <Tooltip title={t('title.chat')}>
          <div className="chat-btn" onClick={() => { handleClose() }}>
            {/* <img src="/assets/images/chat-icons/chatbox-03.svg" alt="chatbox image" width='24px' height='24px'/> */}
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
              viewBox="0 0 512 512" style={{width:'24px',height:'24px',fill:'#FFF'}}>
              <g id="Layer_1">
                <g>
                  <g>
                    <path d="M499.8,12.2v487.5H12.2V12.2H499.8 M500,12H12v488h488V12L500,12z" />
                  </g>
                  <g>
                    <path d="M511.8,0.3v511.5H0.3V0.3H511.8 M512,0H0v512h512V0L512,0z" />
                  </g>
                </g>
              </g>
              <g id="Layer_2">
                <g>
                  <g>
                    <path d="M433.9,196.8h-29.5v73.8c0,40.8-33.1,73.8-73.8,73.8H197.7v29.5c0,32.6,26.4,59.1,59.1,59.1h88.6l64.4,53.6
				c6.3,5.2,15.6,4.4,20.8-1.9c2.2-2.7,3.4-6,3.4-9.5V433c32.6,0,59.1-26.4,59.1-59.1V255.8C493,223.2,466.5,196.8,433.9,196.8z"/>
                  </g>
                  <path d="M315.8,19.6H79.6c-32.6,0-59.1,26.4-59.1,59.1v177.2c0,32.6,26.4,59.1,59.1,59.1l0,0v56.5
			c0,8.1,6.6,14.8,14.8,14.8c3.5,0,6.9-1.3,9.6-3.5l79-67.8h132.9c32.6,0,59.1-26.4,59.1-59.1V78.7
			C374.9,46.1,348.4,19.6,315.8,19.6z M130,188.1c-1.3,1.4-2.8,2.7-4.4,3.7c-1.6,1.1-3.3,2-5,2.8c-1.8,0.7-3.7,1.2-5.6,1.6
			c-1.9,0.4-3.8,0.6-5.8,0.6c-16.3,0-29.5-13.2-29.5-29.5c-0.3-16.3,12.7-29.8,28.9-30.1c2.1,0,4.3,0.1,6.3,0.6
			c1.9,0.4,3.8,0.9,5.6,1.6c1.8,0.7,3.5,1.7,5,2.8c1.6,1,3.1,2.2,4.4,3.5c5.7,5.7,8.9,13.5,8.7,21.6
			C138.7,175.1,135.5,182.6,130,188.1z M218.5,188.1c-5.5,5.6-13,8.7-20.8,8.7c-1.9,0.2-3.8,0.2-5.8,0c-1.9-0.4-3.8-0.9-5.6-1.6
			c-1.8-0.8-3.4-1.7-5-2.8c-1.7-1.1-3.2-2.3-4.6-3.7c-5.6-5.7-8.7-13.4-8.6-21.4c-0.2-1.9-0.2-3.8,0-5.8c0.4-1.9,0.9-3.8,1.6-5.6
			c0.7-1.8,1.7-3.5,2.8-5c1-1.6,2.2-3.2,3.5-4.6c1.4-1.3,3-2.5,4.6-3.5c1.6-1.1,3.2-2.1,5-2.8c2-0.9,4.1-1.7,6.2-2.2
			c16-3.2,31.5,7.2,34.7,23.2c0.4,2.1,0.6,4.2,0.6,6.3c0,7.8-3.1,15.3-8.6,20.8L218.5,188.1L218.5,188.1z M307.1,188.1
			c-1.3,1.4-2.8,2.7-4.4,3.7c-1.6,1.1-3.3,2-5,2.8c-1.8,0.7-3.7,1.2-5.6,1.6c-1.9,0.4-3.8,0.6-5.8,0.6c-16.3,0-29.5-13.2-29.5-29.5
			c-0.3-16.3,12.7-29.8,28.9-30.1c2.1,0,4.3,0.1,6.3,0.6c1.9,0.4,3.8,0.9,5.6,1.6c1.8,0.7,3.5,1.7,5,2.8c1.6,1,3.1,2.2,4.4,3.5
			c5.7,5.7,8.9,13.5,8.7,21.6C315.8,175.1,312.7,182.6,307.1,188.1z"/>
                </g>
              </g>
            </svg>
          </div>
        </Tooltip>
      </div>

      {chatBoxStatus ?
        <div className={classNames('chat-widget', { 'hide': !chatBoxStatus })}>

          <ConversationHeader>
            <ConversationHeader.Content>
              <div className="flex-space-between">
                {
                  isMobile && isMobileInConversation &&
                  <div onClick={() => setShowConversationContainer(false)}>
                    <LeftOutlined />
                  </div>
                }
                <h4>{t('title.chat')} {!isFromSupplier ? "(" + customerList.length + ")" : null} </h4>
                <span><CloseOutlined onClick={() => { handleClose() }} /></span>
              </div>
            </ConversationHeader.Content>

          </ConversationHeader>
          <MainContainer>

            {/*<Sidebar position="left">*/}
            {!isFromSupplier && (!isMobile || isMobileNotInConversation) ?
              <ConversationList>
                <Search placeholder={t('label.search')}
                  onKeyUp={(event) => filterSearch(event)}
                  onClearClick={() => { setReceveSearchTerm('') }}
                // value={receveSearchTerm}
                // onChange={v => setReceveSearchTerm(receveSearchTerm)}
                // onClearClick={() => setReceveSearchTerm("")}
                // onKeyUp={(event) => setReceveSearchTerm(event.target.value)}
                />
                {customerList.filter(user => {
                  return (
                    user?.name?.toLowerCase().indexOf(receveSearchTerm) > -1
                  );
                })
                  .map((user, index) => {

                    return (
                      <Conversation
                        name={user?.name}
                        // info={user?.lastMsg}
                        onClick={() => { fetchSelUser(user, index) }}
                        key={index}
                        className={user?.refID == selCustomer?.refID ? 'active-sidebar' : ''}
                        unreadCnt={user?.total_unread}
                      >
                        <Avatar
                          src={user?.imageUrl ? user.imageUrl : `/assets/images/default-user2.png`}
                          name={user?.name}
                          //  status="available"
                          status={isOnline(user)}
                        />
                      </Conversation>
                    )
                  }

                  )}
              </ConversationList>
              : ''}
            {/*</Sidebar>*/}
            {
              (!isMobile || isMobileInConversation || (isMobile && isFromSupplier)) &&
              <ChatContainer>

                <ConversationHeader>
                  {selCustomer?.conversation.length ? <Avatar src={selCustomer?.imageUrl ? selCustomer.imageUrl : `/assets/images/default-user2.png`} name={selCustomer?.name} /> : null}
                  <ConversationHeader.Content userName={selCustomer?.name} info={selCustomer?.lastActive} onClick={() => { navigateToMerchant(selCustomer) }} />
                </ConversationHeader>
                <MessageList>
                  {selCustomer?.conversation.length ? map(selCustomer.conversation, (info: any, i) => {

                    return (

                      <>

                        <Message
                          key={i}
                          model={{
                            message: info.text,
                            direction: info.direction,
                            //  sentTime: info.createdAt,
                            //sender: info.sender,
                            position: info.position ? info.position : 'single'
                          }}
                        >
                          <Message.Header sender={info.direction == 'incoming' ? info.employeeName : ''} />

                          {info.displayOption == "ORDER" &&
                            <Message.HtmlContent html={info.text} />
                          }
                          {info.displayOption == "PRODUCT" &&
                            <Message.CustomContent>
                              {
                                info.attachments_data ? info?.attachments_data?.map((fileObj) => {
                                  return <div className='product-bg'><img src={fileObj?.file_url} alt={fileObj?.fileName} width={'100px'} height={'100px'} onClick={() => { viewImage(fileObj?.file_url) }} />
                                    <Message.HtmlContent html={info.text} />
                                  </div>
                                })
                                  : <span><Message.HtmlContent html={info.text} /></span>
                              }
                            </Message.CustomContent>
                          }


                          {info.displayOption == "TEXT" &&
                            <Message.CustomContent>
                              {
                                info.attachments_data ? info?.attachments_data?.map((fileObj) => {
                                  return <div className='product-bg'><img src={fileObj?.file_url} alt={fileObj?.fileName} width={'100px'} height={'100px'} onClick={() => { viewImage(fileObj?.file_url) }} />
                                  </div>
                                })
                                  : <span><Message.HtmlContent html={info.text} /></span>
                              }
                            </Message.CustomContent>
                          }
                          <Message.Footer sender=""
                            sentTime={info.time ? info.time : moment(new Date()).format('hh:mm A')}
                          />
                          {/* {info.attachments_data ? null : <Message.Footer sender=""
                            sentTime={info.time ? info.time : null}
                          />} */}
                        </Message>

                      </>
                    )
                  }) : <div className="empty-chat-section">
                    <img src={`/assets/images/chat-icon.svg`} className="image" />
                    <p>{t('txt.chatHistoryEmpty')}</p><p>{t('txt.letsStartChatToCommunicate')}</p>
                  </div>}

                </MessageList>

                <MessageInput
                  placeholder="Type message here"
                  onAttachClick={onAttachClick}
                  onChange={onChange}
                  onSend={onSend}
                  value={input.message}
                  autoFocus={true}
                  sendDisabled={(input.message && sendStatus == 'idle') ? false : true} />
                : null


                {/* <div as={MessageInput}>

                  {showPopup ? <div className="popup-content">
                    <div className='img-name' onClick={productsUpload}>
                      <img src='assets/images/chat-image.svg' />
                      <span>{t('label.product')}</span></div>
                    <div className='img-name' onClick={ordersUpload}>
                      <img src='assets/images/chat-image.svg' />
                      <span>{t('label.order')}</span></div>
                    <div className='img-name' onClick={localFileUpload}>
                      <img src='assets/images/chat-image.svg' />
                      <span>{t('label.image')}</span></div>
                  </div> : ''}

                  {input.selUser ? <MessageInput
                    onAttachClick={onOpenPopover}
                    placeholder={t('placeholder.typeMessageHere')}
                    onChange={onChange}
                    onSend={onSend}
                    value={input.message}
                    sendDisabled={(input.message && sendStatus == 'idle') ? false : true}
                  /> : ''}

                </div> */}

              </ChatContainer>
            }
          </MainContainer>
        </div>
        : ''}

      <BasicModal
        destroyOnClose={true}
        isOpen={isOpen}
        isClosable={true}
        onClose={closeModal}
        isMaskClosable={true}
      >
        <img src={imageUrl} width={'100%'} />
      </BasicModal>
    </div>
  )
}

